import { create } from "zustand"

type ConfigureExportDialogStore = {
  open: boolean
  openDialog: () => void
  closeDialog: () => void
}

export const useConfigureExportDialogStore = create<ConfigureExportDialogStore>((set) => ({
  open: false,
  openDialog: () => set({ open: true }),
  closeDialog: () => set({ open: false }),
}))
